/* Stylesheet */

.numeric_select {
  padding: 0px 21px 21px 21px;
}
